import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randCompanyName } from '@ngneat/falso'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type DepartmentGroupData = SchemaAttributes<'DepartmentGroup'>

export const model = Model as ModelDefinition<DepartmentGroupData>

export const factory = Factory.extend<DepartmentGroupData>({
  name() {
    return randCompanyName()
  },
  archived(index: number) {
    return index % 2 === 0
  },
})

export function seeds(server: MockServer) {
  server.create('departmentGroup', { name: randCompanyName() })
  server.create('departmentGroup', { name: randCompanyName() })
}
